module.exports = __webpack_public_path__ + "img/promolider_logo_collapse.84c79a95.png";